import LpuRepository from '@/shared/http/repositories/pci/lpu'
import ActionsForm from '@/shared/mixins/actionsForm'
import Data from '@/shared/models/pci/lpumodel'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import { AgGridVue } from 'ag-grid-vue'
import moment from 'moment'
import draggable from 'vuedraggable'
import gridMixin from '../mixins/gridMixin'
import AddItemDetail from './addItemDetail.vue'
import Form from './lpu-form'

export default {
  name: 'Lpu',
  mixins: [ActionsForm, CompanyMixin, gridMixin],
  components: {
    AgGridVue,
    AddItemDetail,
    draggable
  },
  data () {
    return {
      objListOrg: [],
      objList: [],
      form: Form,
      data: Data,
      itemNew: '',
      customColumnNew: '',
      showAddItemDetailIndex: -1,
      editItemDetailIndex: -1,
      showExcelIcons: false,
      showRevised: false,
      showExcluded: false,
      rowSelected: null,
      isChanged: false,
      tipoItemOptions: [
        {value: 0, text: this.$lang.PCI.Lpu.ItemType0},
        {value: 1, text: this.$lang.PCI.Lpu.ItemType1},
        {value: 2, text: this.$lang.PCI.Lpu.ItemType2}
      ],
      tipoAgrupamentoOptions: [
        {value: 0, text: this.$lang.PCI.Lpu.GroupType0},
        {value: 1, text: this.$lang.PCI.Lpu.GroupType1},
        {value: 2, text: this.$lang.PCI.Lpu.GroupType2}
      ],
      searchField: '',
      lpuGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          sortable: true,
          suppressMovable: true,
          lockVisible: true,
          minWidth: 30
        }
      },
      columnDefs: [
        {
          headerName: this.$lang.PCI.Lpu.DataTable.Client,
          field: 'cliente',
          width: 90
        },
        {
          headerName: this.$lang.PCI.Lpu.DataTable.Desctiption,
          field: 'descricao',
          width: 220
        },
        {
          headerName: this.$lang.PCI.Lpu.DataTable.Region,
          field: 'regiao',
          width: 90
        },
        {
          headerName: this.$lang.PCI.Lpu.DataTable.Creation,
          field: 'dataAcao',
          valueFormatter: params => {
            if (params.value) {
              let format = ''
              const mt1 = params.value.match(/^\d\d\/\d\d\/\d\d\d\d$/g)
              const mt2 = params.value.match(/^\d\d\/\d\d\/\d\d$/g)
              if (mt1) format = 'dd/MM/yyyy'
              if (mt2) format = 'dd/MM/yy'
              return params.value !== '#NA#' && params.value !== '#NREF#' ? moment(params.value, format).toDate().toLocaleDateString() : null
            }
            return null
          },
          width: 100
        },
        {
          headerName: 'Rv.',
          field: 'revisao',
          width: 70
        },
        {
          headerName: 'Sit.',
          valueGetter: params => {
            return params.data.status > 0 ? 'Ativo' : params.data.status > -1 ? 'Rev.' : 'Excl.'
          },
          width: 80
        }
      ]
    }
  },
  methods: {
    onLoad () {
      this.showExcelIcons = Boolean(this.data.id)
      this.onClearForm()
      LpuRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.objListOrg = response.data.data
            this.processList()
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
    },
    processList () {
      this.objList = this.objListOrg.filter(ol => {
        return (this.showExcluded && ol.status === -1) || (this.showRevised && ol.status === 0) || ol.status === 1
      })
    },
    onSelectRow (data) {
      this.rowSelected = data.api.getSelectedRows().length > 0 ? data.api.getSelectedRows()[0] : null
    },
    onSelect () {
      const data = this.lpuGridOptions.api.getSelectedRows()[0]
      loading.push()
      LpuRepository.Get(data.id)
        .then(response => {
          if (response.data.code > 0) {
            this.onEdit(response.data.data)
            this.$nextTick(() => {
              this.showExcelIcons = true
              this.$refs.txtDescricao.$el.focus()
            })
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onCreate () {
      this.data.empresaID = this.company.id
      loading.push()
      LpuRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.data.id = response.data.data.id
            this.showExcelIcons = true
            this.onLoad()
            // this.onSelect(response.data.data)
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdate () {
      if (this.isChanged) {
        loading.push()
        LpuRepository.Update(this.data)
          .then(response => {
            if (response.data.code > 0) {
              toast.success(this.$lang.Common.Alerts.Success)
              // this.data.id = response.data.data.id
              // this.showExcelIcons = true
              this.onLoad()
              // this.onSelect(response.data.data)
            } else {
              toast.error(response.data.message || this.$lang.Common.CouldNotSave)
            }
          })
          .catch(err => this.onException(err))
          .finally(() => loading.close())
      } else {
        this.onClearForm()
      }
    },
    onDelete () {
      const item = this.lpuGridOptions.api.getSelectedRows()[0]
      loading.push()
      LpuRepository.Delete(item.id)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.onLoad()
          } else {
            toast.error(response.data.message || this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onClearForm () {
      this.showExcelIcons = false
      this.onClear()
      this.form.revisao.value = 1
    },
    setInitialColor (item) {
      this.$set(item, 'cor', '#ffffff')
    },
    unsetColor (item) {
      this.$set(item, 'cor', null)
    },
    onSaveForm () {
      this.onSave()
    },
    onSaveObservation () {
      loading.push()
      const data = {
        id: this.data.id,
        observacao: this.form.observacao.value
      }
      LpuRepository.UpdateObservation(data)
        .then(response => {
          if (response.data.code > 0) {
            this.data.observacao = this.form.observacao.value
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onSaveRevision (item) {
      loading.push()
      LpuRepository.CreateRevision(item)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.onLoad()
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onNewItem () {
      if (!this.itemNew) return
      if (!this.form.itens.value) this.form.itens.value = []
      const lastOrdem = this.form.itens.value.reduce((value, obj) => {
        return Math.max(obj.ordem, value)
      }, 0)
      this.form.itens.value.push({
        lpuId: this.data.id || '00000000-0000-0000-0000-000000000000',
        sequencia: '',
        descricao: this.itemNew,
        tipoItem: 0,
        tipoAgrupamento: 1,
        ordem: lastOrdem + 1,
        lpuItemDetalhe: {}
      })
      this.itemNew = ''
      this.$nextTick(() => {
        const refs = this.$refs.txtSequence
        if (Array.isArray(refs) && refs.length) {
          refs[refs.length - 1].$el.focus()
        } else {
          refs.$el.focus()
        }
      })
    },
    onRemoveItem (index) {
      this.isChanged = true
      this.form.itens.value.splice(index, 1)
    },
    onMoveItem () {
      this.isChanged = true
      let pos = 1
      this.form.itens.value.forEach(it => {
        it.ordem = pos++
      })
    },
    onEditItemDetail (index) {
      this.editItemDetailIndex = index
      this.$refs.addItemDetail[index].onShow(this.form.itens.value[index], this.form.colunas.value)
    },
    onOkItemDetail (item) {
      this.form.itens.value[this.editItemDetailIndex] = item
      this.editItemDetailIndex = -1
    },
    onSortSequence () {
      if (!(this.form.itens.value && this.form.itens.value.length)) return
      this.form.itens.value = this.form.itens.value.sort((a, b) => a.sequencia < b.sequencia ? -1 : a.sequencia > b.sequencia ? 1 : 0)
      this.$nextTick(() => {
        this.$refs.txtItemNovo.$el.focus()
      })
    },
    onToggleAddItemDetail (index) {
      this.showAddItemDetailIndex = this.showAddItemDetailIndex === index ? -1 : index
    },
    onNewCustomColumn () {
      if (!this.customColumnNew) return
      if (!this.form.colunas.value) this.form.colunas.value = []
      this.showExcelIcons = false
      this.form.colunas.value.push({
        lpuId: this.data.id || '00000000-0000-0000-0000-000000000000',
        rotulo: this.customColumnNew
      })
      this.customColumnNew = ''
      this.$nextTick(() => {
        this.$refs.txtNewCustomColumn.$el.focus()
      })
    },
    onRemoveCustomColumn (index) {
      this.isChanged = true
      this.form.colunas.value.splice(index, 1)
    },
    onDownloadTemplate () {
      loading.push()
      LpuRepository.Download(this.data.id)
        .then(response => {
          if (response.data.code > 0) {
            const data = Uint8Array.from(atob(response.data.data.file), c => c.charCodeAt(0))
            const blob = new Blob([data], {type: response.data.data.contentType})
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = response.data.data.name
            link.click()
            URL.revokeObjectURL(link.href)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUploadFile (event) {
      if (event.target.files) {
        const file = event.target.files[0]
        const formData = new FormData()
        formData.append('file', file)
        loading.push()
        LpuRepository.Upload(this.data.id, formData)
          .then(response => {
            if (response.data.code > 0) {
              this.onClearForm()
              this.onLoad()
            } else {
              toast.error(response.data.message || this.$lang.Commom.Alerts.Error)
            }
          })
          .catch(err => this.onException(err))
          .finally(() => loading.close())
      }
      this.$refs.UploadFile.value = ''
    },
    onGridReady () {
      setTimeout(() => {
        this.lpuGridOptions.api.sizeColumnsToFit()
      }, 500)
    },
    onClearSearch () {
      this.searchField = ''
      this.onSearchFieldChanged()
    },
    onSearchFieldChanged () {
      this.lpuGridOptions.api.setQuickFilter(this.searchField)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/lpu/lpu.js